package anjuros.development.components

import androidx.compose.runtime.Composable
import anjuros.development.components.language.LocalText
import anjuros.development.components.language.ResKey
import anjuros.development.modules.Room
import anjuros.development.util.Constants
import anjuros.development.util.RoomCardSizeStyle
import anjuros.development.util.RoomCardStyle
import anjuros.development.util.RoomImageStyle
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun RoomCard(
    room: Room,
    animatedOpacity: Float,
    animatedMargin: CSSLengthOrPercentageNumericValue,
    onClick: (room: Room) -> Unit
) {

    Box(
        modifier = RoomCardStyle.toModifier()
        .cursor(Cursor.Pointer)
        .onClick { onClick(room) }
        .margin(top = animatedMargin, bottom = 30.px)
        .opacity(animatedOpacity)
        .transition(
            Transition.of(
                "margin", 900.ms,
                delay = 500.ms * room.ordinal
            ),
            Transition.of(
                "opacity", 900.ms,
                delay = 500.ms * room.ordinal
            )
        )
    ) {

        Column(

            modifier = RoomCardSizeStyle.toModifier()
                .id("roomBorder"),
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Image(
                modifier = RoomImageStyle.toModifier()
                    .borderRadius(topRight = 28.px, topLeft = 28.px)
                    .objectFit(ObjectFit.Fill),
                src = room.image,
                alt = "${LocalText(ResKey.SECTION_ROOMS)} koło Białki Tatrzańskiej"
            )
            Column(
                modifier = Modifier
                    .align(Alignment.CenterHorizontally)
                    .id("roomInformation"),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                P(
                    attrs = Modifier
                        .id("roomTitle")
                        .align(Alignment.CenterHorizontally)
                        .margin(topBottom = 5.px)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .fontWeight(FontWeight.Bold)
                        .toAttrs()
                ) {
                    Text(LocalText(room.title))
                }
                P(
                    attrs = Modifier
                        .id("roomTitle")
                        .align(Alignment.CenterHorizontally)
                        .textAlign(TextAlign.Center)
                        .margin(5.px)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.Normal)
                        .toAttrs()
                ) {
                    Text(LocalText(room.desc))
                }
            }
        }
    }
}